import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, catchError, finalize, map, throwError } from 'rxjs';
import { DialogErrors } from '../dialog-errors/dialog-errors';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { environment } from '../environments/environment';

declare var $ :any;

@Injectable({
  providedIn: 'root'
})
export class SettingsService {



  public static API_ENDPOINT:string = environment.API_ENDPOINT;
  public static lemu_base:string = environment.lemu_base;
  public static WS_URL:string = environment.WS_URL;

  get_query(http: number, query: string, value: any = {}, wo_options: boolean = false) {
    const endpoint = `${SettingsService.API_ENDPOINT}${query}`;
    const token = this.get_token();

    const headers: any = new HttpHeaders().set("Authorization", "JWT " + token);
    let req: any = new Observable();

    switch (http) {
      case 1:
        req = wo_options ? this.http.get(endpoint, { observe: 'response' }) : this.http.get(endpoint, { headers, observe: 'response' });
        break;
      case 2:
        req = wo_options ? this.http.post(endpoint, value, { observe: 'response' }) : this.http.post(endpoint, value, { headers, observe: 'response' });
        break;
      case 3:
        req = wo_options ? this.http.put(endpoint, value, { observe: 'response' }) : this.http.put(endpoint, value, { headers, observe: 'response' });
        break;
      case 4:
        req = this.http.delete(endpoint, { headers, observe: 'response' });
        break;
      default:
        req = wo_options ? this.http.get(endpoint, { observe: 'response' }) : this.http.get(endpoint, { headers, observe: 'response' });
        break;
    }

    return new Promise((resolve, reject) => {
      req.subscribe(
        (response: HttpResponse<any>) => {
          var status = response.status;
          //hay muchos endpoint que solo tienen 200 en el switch case, y hay respuestas que marcan 201,
          //para corregir temporalmente esto, se asignaran todas las respuestas positivas a 200
          if(status == 201){
            status = 200;
          }
          const body = response.body;
          resolve({ '_body':body, 'status':status });
        },
        (_error: any) => {
          const statusCode = _error.status;
          const status = statusCode
          const error = _error.error
          const _body = _error;
          reject({ _body, error, statusCode, status });

          if(statusCode == 401 || statusCode == 403){
            const username = localStorage.getItem('username');
            const password = localStorage.getItem('password');

            this.snackBar.open("Tu inicio de sesión caduco, por favor vuelve a iniciar sesión", "Aceptar", {
              duration: 20000,
              panelClass: "simpli-snack"
            });

            localStorage.clear();
            if (username !== null && password !== null) {
              localStorage.setItem('username', username);
              localStorage.setItem('password', password);
            }
          }
        }
      );
    });
  }



  manage_errors(status:any, view:any, body:any, show_dialog_errors=true) {
    switch (status) {
      case 400:
        if (show_dialog_errors) {
          this.show_errores(body, view);
        }
      break;
      case 404:
        this.snackBar.open("Si tienes problemas para ingresar comunícate con el área de soporte o tu ejecutivo", "Aceptar", {
          duration: 20000,
          panelClass: "simpli-snack"
        });
      break;
      case 500:
        this.snackBar.open("Ocurrió un error, intenta de nuevo", "Aceptar", {
          duration: 20000,
          panelClass: "simpli-snack"
        });
        this.send_mail_500(view, body);
      break;
      default:

      break;
    }
  }

  async send_mail_500(view:any, body:any) {
    try {
      var value = {
        "view": view,
        "status": body.status,
        "statusText": body.statusText,
        "type": body.type,
        "url": body.url,
        "body": body._body,
      }
      const bd: any = await this.get_query(2, 'cliente/alert-fail/', value, true);
      var body_data: any =bd._body;

      switch (bd.status) {
        case 200:

        break;
        default:

        break;
      }

    } catch (bd: any) {

    }
  }

  show_errores(bd:any, view:any) {
    var body_data: any =bd._body;
      var body_errors = body_data.error.errors;
      var keys = Object.keys(body_data.error.errors);
      var errores = []
      for (let index = 0; index < keys.length; index++) {
        const element = keys[index];
        const error = body_errors[element];
        for (let index = 0; index < error.length; index++) {
          errores.push(error[index])
        }
      }
      this.dialogo_errores("Información de errores",view,"Advertencia",view,"error","#fba75ffa",errores);
  }

  dialogo_errores(title:any, subtitle:any, mensajeprincipal:any, mensajenegrita:any, icon:any, coloricon:any, errores:any){
    const dialogRef = this.dialog.open(DialogErrors,{
      width:'700px',
      autoFocus: false,
    });
    dialogRef.componentInstance.title = title;
    dialogRef.componentInstance.subtitle = subtitle;
    dialogRef.componentInstance.mensajeprincipal = mensajeprincipal;
    dialogRef.componentInstance.mensajenegrita = mensajenegrita;
    dialogRef.componentInstance.icon = icon;
    dialogRef.componentInstance.coloricon = coloricon;
    dialogRef.componentInstance.errores = errores;


    dialogRef.afterClosed().subscribe((result:any) => {

    });

  }

  verify_out() {
    if (localStorage.getItem("token") != null) {
      this.router.navigate(['home']);
    }
  }

  formatMoney(amount: any, decimalCount = 2, decimal = ',', thousands = '.') {
    try {
        decimalCount = Math.abs(decimalCount);
        decimalCount = isNaN(decimalCount) ? 2 : decimalCount;
        const negativeSign = amount < 0 ? '-' : '';
        const i = parseInt((amount = Math.abs(Number(amount) || 0).toFixed(decimalCount))).toString();
        const j = (i.length > 3) ? i.length % 3 : 0;
        return negativeSign + (j ? i.substr(0, j) + thousands : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, '$1' + thousands);
    } catch (e) {
        return '';
    }
  }

  get_token(sw = null) {
    return localStorage.getItem("token");
  }

  empty_local_data() {
    localStorage.removeItem("token");
    localStorage.removeItem("role");
    this.router.navigate(['login']);
  }

  set_initial_overflow() {
    $(window).scrollTop(0);
  }

  constructor(private router: Router, public snackBar: MatSnackBar, public dialog: MatDialog, private http: HttpClient) {

  }
}
